<template>
  <div class="settings">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'settings',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>
